export const DEFAULT_FETEBUDDY_PROMPT_KEYS = {
    'START': "FETEBOARD_FETEBUDDY",
    'CONTINUE': "FETEBOARD_CONTINUE",
    'GENERATE_SESSION_TITLE': "GENERATE_SESSION_TITLE",
}

export const DEFAULT_FETEBUDDY_INITIATE_MESSAGES: any = {
    'START': "Start FeteBuddy",
    'CONTINUE': "Continue FeteBuddy"
}

export const CHAT_SESSION = {
    'DRAFT_TITLE': "Draft Session"
}

export const MESSAGE_TYPES = {
    AI: 'ai',
    HUMAN: 'human'
}